import React from 'react'
import cn from 'classnames'

import Text from './Text'
import ContactButton from './ContactButton'
import styles from './Contact.module.css'
import config from '../config'

export default () => (
  <div className={styles.container}>
    <div className="reveal">
      <h2>Want to Work With Us?</h2>
      <ContactButton />
      <div className={styles.indicator}>
        <div className={styles.dots}>
          <div className={styles.dot} />
          <div className={styles.dot2} />
          <div className={styles.dot3} />
        </div>
      </div>
      <Text size="small" style={{ textAlign: 'center'}}>or simply <a href={`mailto:${config.mail}`}>{config.mail}</a></Text>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Contact.js